//  Function: animateScroll()
//  Author: Dustin Miller & Sarah McVicker
//  Date: 2017-01-24
//  Requires: jQuery

(function($){
  $.fn.animateScroll = function(options){
    // eslint-disable-next-line no-unused-vars
    var settings = $.extend({
      // default settings
      scrollToEl: this,
      speed: 600,
      offset: [
        {
          minWidth: 0,
          offsetSize: 0,
          offsetEl: null
        }
      ]
    }, options);

    this.on('click', function(e){
      e.preventDefault();

      var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
          highestOffset = 0,
          offset = 0,
          scrollToEl = $(this).attr('href'),
          $el = $(scrollToEl);

      $.each(settings.offset, function(i, val){
        if(viewportWidth >= val.minWidth && highestOffset < val.minWidth){
          offset = 0;
          
          if(('offsetSize' in val)){
            offset = val.offsetSize;
          }
          if(('offsetEl' in val) && val.offsetEl.length){
            var offsetEl =  val.offsetEl.first(),
                offsetElSize = offsetEl.outerHeight(true);

            offset += offsetElSize;
          }
          
          highestOffset = val.minWidth;
        }
      });

      $('html, body').animate({scrollTop: $el.offset().top - offset}, settings.speed);
      $el.focus();
    });

    return this;
  }; 
})($JQ);